import {Injectable} from '@angular/core';
import {Command} from './command.model';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../../src/environments/environment';

@Injectable()
export class CommandApiService {

  public baseUrl = environment.backEndUrlPrefix + '/' + 'db/command';

  constructor(private http: HttpClient) {
  }

  public getAll(): Observable<Command[]> {
    return this.http.get<Command[]>(this.baseUrl)
      .pipe(
        // catchError(this.handleError('getHeroes', []))
      );
  }

}
